export default __webpack_public_path__ + "static/media/sf-roza2.b3e9ece1.jpg";